/** Rótulos de UI do guia — etapas, ferramentas e recursos. */

export const GUIA_LABELS = {
  etapaAtual: 'Etapa atual',
  etapa: 'Etapa',
  etapas: 'Etapas',
  searchKindEtapa: 'Etapa',
  searchPlaceholder: 'Buscar etapas, ferramentas e telas…',
  continuarEtapa: 'Continuar etapa',
  verEtapaAtual: 'Ver etapa atual',
  abrirEtapa: 'Abrir etapa',
  verNaEtapaGuia: 'Ver na etapa do guia',
  concluirEtapa: 'Concluir etapa',
  marcarEtapaConcluida: 'Marcar etapa como concluída',
  desmarcarEtapaConcluida: 'Desmarcar etapa concluída',
  situacaoDestaEtapa: 'Situação desta etapa',
  progressoDestaEtapa: 'Progresso desta etapa',
  decisaoDestaEtapa: 'Resumo desta etapa',
  secoesDaEtapa: 'Seções da etapa',
  navegacaoDaEtapa: 'Navegação da etapa',
  diarioDaEtapa: 'Diário desta etapa',
  dadosObraNestaEtapa: 'Dados da obra nesta etapa',
  nestaEtapa: 'nesta etapa',
  destaEtapa: 'desta etapa',
  todasEtapas: 'Todas as etapas',
  guiaEtapaAEtapa: 'Guia etapa a etapa',
  resumoDaEtapa: 'Resumo da etapa',
  etapaGuiaEmAndamento: 'Etapa do guia em andamento',
  buscarEtapasGuia: 'Buscar etapas do guia',
  nenhumaEtapaEncontrada: 'Nenhuma etapa encontrada.',
  proximaEtapa: 'Próxima etapa',
  ferramentasIndex: 'Ferramentas',
  ferramentasIndexDesc: 'Calculadoras, checklists e recursos de cada etapa',
  recursoBadge: 'Recurso',
  tipoFerramenta: 'Recurso',
  recursoEtapaTitulo: 'Recurso da etapa',
  recursoUtilizado: 'Utilizado',
  recursoNaoUtilizado: 'Não utilizado',
  searchKindFerramenta: 'Ferramenta',
  ferramentaOverline: 'Ferramenta',
  ferramentaFallback: 'Ferramenta',
  ferramentaNaoEncontrada: 'Ferramenta não encontrada',
  verFerramentas: 'Ver ferramentas',
  ferramentaBadge: 'Ferramenta',
  etapaObraDesc: 'Recurso desta etapa. Preencha com os dados da sua obra.',
  ferramentasIndexAlert:
    'Cada ferramenta abre de forma isolada. Os resultados ficam salvos para reutilizar na etapa correspondente.',
  ferramentasIndexSubtitle:
    'Índice de recursos do guia. No dia a dia, abra pela etapa em que você está.',
} as const
